import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {ConstantService} from '../../constant/constant.service';

@Injectable({
  providedIn: 'root'
})
export class PartnerService {

  constructor(
    private constantService: ConstantService,
    private http: HttpClient
  ) {
  }

  get(param: Array<object>) {
    if (!param.length) return this.http.get(this.constantService.getUrl(this.constantService.PARTNERS));
    else return this.http.get(this.constantService.getUrlByQuery(this.constantService.PARTNERS, param));
  }

  getById(id: string) {
    return this.http.get(this.constantService.getUrl(this.constantService.PARTNERS, [id]));
  }

  post(body: Object) {
    return this.http.post(this.constantService.getUrl(this.constantService.PARTNERS), body);
  }

  put(id, body) {
    return this.http.put(this.constantService.getUrl(this.constantService.PARTNERS, [id]), body);
  }

  getPartners(params?: any) {
    return this.http.get(this.constantService.getUrl(this.constantService.PARTNERS), {
      params: params,
      observe: 'response'
    }).map((resp: any) => {
      let count = resp.headers.get('X-Total-Count');
      return {count: parseInt('1'), data: resp.body.data}
    })
  }

}
